module.exports = require("./ms-MY");